// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__IZbB5","modal_header":"styles_modal_header__T44V_"};